export default __webpack_public_path__ + "static/media/Shop-6.be4dc7c5.webp";